import { render, staticRenderFns } from "./AdminPanelDashboardMenu.vue?vue&type=template&id=43258ed3"
import script from "./AdminPanelDashboardMenu.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboardMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboardMenu.vue?vue&type=style&index=0&id=43258ed3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports